<template lang="html">
  <step
    :complete='complete'
    :step='step'
    :icon='icon'
    :title='title'>
    <v-container fluid>
      <v-layout
        row
        wrap
        v-for='stop in stops'
        :key='stop.id'>
        <v-flex
          xs12
          md6>
          <v-icon color='primary'>
            mdi-map-marker
          </v-icon>
          <span> {{ stop.location }} </span>
        </v-flex>
        <v-flex
          xs12
          md6
          v-if='stop.id != stops[stops.length - 1].id'>
          <v-icon color='primary'>
            mdi-calendar
          </v-icon>
          <span>
            {{ formatDate(stop.date) }} {{ stop.time }}
          </span>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        justify-center
        class='summary'>
        <v-flex
          xs4
          v-for='item in summary'
          :key='item.id'>
          <v-layout justify-center row wrap>
            <v-flex xs12>
              <v-icon color='primary'>
                {{ item.icon }}
              </v-icon>
            </v-flex>
            <v-flex xs12>
              <span>{{ item.text }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <slot name='actions'>
      <v-btn
        color='secondary'
        @click='window.location.reload()'>New Quote</v-btn>
    </slot>
    <!--
      Figure out a clean method where we DONT have to refresh the page.
      This will likely involve clearing the store and emitting to parent.
      Page reload is good enough for now.
    -->
  </step>
</template>

<script>
import { mapGetters } from 'vuex'
import Step from './Step'
export default {
  components: {
    step: Step
  },
  props: {
    complete: Boolean,
    step: [ Number, String ],
    stops: Array,
    trip: Object,
    quote: Object
  },
  data: vm => ({
    icon: 'mdi-check-circle',
    title: 'Quote Review'
  }),
  computed: {
    summary () {
      return [
        {
          id: 1,
          text: `${this.trip.passengers} passengers`,
          icon: 'mdi-account-group'
        },
        {
          id: 2,
          text: `$${this.quote.cost}`,
          icon: 'mdi-currency-usd'
        },
        {
          id: 3,
          text: `${this.quote.live_miles} mi.`,
          icon: 'mdi-map-marker-distance'
        }
      ]
    },
    ...mapGetters('dates', {date: 'byId'})
  },
  methods: {
    formatDate (d) {
      if (d === null) {
        return 'No Date Selected'
      }
      return this.date(d).date
    }
  }
}
</script>

<style lang="css" scoped>
</style>
